import type { Company } from '../lib/api';

/** True when a company row can toggle supplier/customer portal view. */
export function companySupportsDualPortal(
  company: Pick<Company, 'company_type' | 'portal_mode' | 'supports_dual_portal'> | null | undefined,
): boolean {
  if (!company || company.company_type === 'customer') return false;
  return company.supports_dual_portal === true || company.portal_mode === 'both';
}

/** Resolve dual-mode toggle visibility for home company + selected scope. */
export function resolveSupportsDualMode(
  homeCompany: Company | null,
  dbSupportsDual: boolean | undefined,
  accessibleCompanies: Company[],
  scopeCompanyId: number | null | undefined,
  scopeSiteId: number | null | undefined,
  isHelixStaff: boolean,
): boolean {
  if (companySupportsDualPortal(homeCompany)) return true;
  if (dbSupportsDual === true) return true;
  const scopeId = scopeSiteId ?? scopeCompanyId;
  if (scopeId) {
    const scoped = accessibleCompanies.find((c) => c.id === scopeId);
    if (companySupportsDualPortal(scoped)) return true;
  }
  if (isHelixStaff && accessibleCompanies.some((c) => companySupportsDualPortal(c))) {
    return true;
  }
  return false;
}

/** Resolve display name from accessible companies when detail fetch fails. */
export function nameForCompanyId(
  accessibleCompanies: Company[],
  id: number | null | undefined,
): string | null {
  if (!id) return null;
  return accessibleCompanies.find((c) => c.id === id)?.name ?? null;
}
